var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5023 2.45333c-.7171.30938-1.4976.53203-2.3015.61875.8346-.49585 1.4596-1.27922 1.7578-2.203125-.7832.465915-1.6412.792615-2.5359.965625-.374-.39978-.8263-.71827-1.3287-.935608-.5024-.217341-1.0442-.328882-1.5917-.327673-2.2148 0-3.99605 1.795311-3.99605 3.998441 0 .30937.0375.61875.09844.9164-3.31641-.17343-6.27422-1.75781-8.24063-4.18359-.3583.61199-.546059 1.30881-.543748 2.01797 0 1.3875.705468 2.61094 1.781248 3.33047-.63397-.02497-1.2531-.19923-1.807029-.5086v.04922c0 1.94297 1.373439 3.55313 3.203909 3.92339-.34369.0893-.69725.135-1.05235.136-.26015 0-.50625-.0258-.75468-.0609.50625 1.5843 1.98046 2.7351 3.73593 2.7726-1.37343 1.0758-3.09375 1.7086-4.961715 1.7086-.335156 0-.644531-.0117-.965625-.0492 1.77187 1.1367 3.87422 1.7929 6.13828 1.7929 7.35002 0 11.37192-6.089 11.37192-11.37417 0-.17344 0-.34688-.0118-.52031.7782-.56953 1.4602-1.275 2.0039-2.06719Z",
    fill: "#444443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.975074a9c442492c8efc38d22dc9524d.svg";
export { ForwardRef as ReactComponent };